// extracted by mini-css-extract-plugin
module.exports = {"video":"TutorialVideo_video__9nFYq"};